import { Controller } from "stimulus"

export default class extends Controller {
  resultsContainers = []

  connect() {
    this.initAutocomplete()
  }

  disconnect() {
    this.resultsContainers.forEach(container => container.remove())
    this.resultsContainers = []
  }

  initAutocomplete() {
    const inputs = this.element.querySelectorAll(".js-search-form")
    inputs.forEach(input => {
      this.setupAddressAutocomplete(input)
    })
  }

  setupAddressAutocomplete(input) {
    const resultsContainer = document.createElement('div')
    resultsContainer.className = 'autocomplete-results'
    resultsContainer.style.cssText = 'position:absolute;top:100%;left:0;z-index:1000;background:#fff;border:1px solid #ddd;border-top:none;max-height:200px;overflow-y:auto;width:100%;display:none;'
    input.parentNode.style.position = 'relative'
    input.parentNode.appendChild(resultsContainer)

    // Ensure parent card does not clip the dropdown
    const card = input.closest('.card')
    if (card) {
      card.style.overflow = 'visible'
      card.style.position = 'relative'
      card.style.zIndex = '10'
    }
    this.resultsContainers.push(resultsContainer)

    let debounceTimer = null

    input.addEventListener('input', () => {
      clearTimeout(debounceTimer)
      const query = input.value.trim()
      if (query.length < 3) {
        resultsContainer.style.display = 'none'
        return
      }
      debounceTimer = setTimeout(() => {
        fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(query)}&limit=5`)
          .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`)
            return res.json()
          })
          .then(data => {
            resultsContainer.innerHTML = ''
            if (data.features && data.features.length > 0) {
              data.features.forEach(feature => {
                const item = document.createElement('div')
                item.className = 'autocomplete-item'
                item.style.cssText = 'padding:8px 12px;cursor:pointer;border-bottom:1px solid #eee;'
                item.textContent = feature.properties.label
                item.addEventListener('mouseenter', () => { item.style.backgroundColor = '#f0f0f0' })
                item.addEventListener('mouseleave', () => { item.style.backgroundColor = '#fff' })
                item.addEventListener('mousedown', (e) => {
                  e.preventDefault()
                  input.value = feature.properties.label
                  resultsContainer.style.display = 'none'
                  const form = input.closest('form')
                  if (form) form.submit()
                })
                resultsContainer.appendChild(item)
              })
              resultsContainer.style.display = 'block'
            } else {
              resultsContainer.style.display = 'none'
            }
          })
          .catch(() => {
            resultsContainer.style.display = 'none'
          })
      }, 300)
    })

    input.addEventListener('blur', () => {
      setTimeout(() => { resultsContainer.style.display = 'none' }, 200)
    })
  }
}
